import { fillLayers, matchColor, pick, titleCase, type LayerStyle } from "./types";

const FULL = "#2c85b1";
const LIMITED = "#8e6bd6";
const ETJ = "#aa711d";

const color = matchColor("JURISDICTION_TYPE", [
  ["FULL", FULL],
  ["LTD", LIMITED],
  [["2MILE", "2MILE_AG", "5MIL"], ETJ],
]);

const style: LayerStyle = {
  id: "coa-jurisdictions",
  minzoom: 8,
  maxzoom: 14,
  layers(source) {
    return fillLayers(this, source, color, 0.15);
  },
  legend: [
    { label: "Austin full purpose", color: FULL },
    { label: "Austin limited purpose", color: LIMITED },
    { label: "Extraterritorial jurisdiction (ETJ)", color: ETJ },
  ],
  describe: (p) =>
    pick(p, [
      ["JURISDICTION_LABEL", "Jurisdiction", titleCase],
      ["CITY_NAME", "City", titleCase],
    ]),
};

export default style;
